import { Observable, UnaryFunction, pipe } from 'rxjs';
import { tap, finalize, switchMap } from 'rxjs/operators';
import { Loader, LoaderType } from '../utils/loader.util';

export const trackExecution = <T, U>(
  key: LoaderType,
  source: (action: T) => Observable<U>,
  loader = Loader.instance,
): UnaryFunction<Observable<T>, Observable<U>> => {
  const operator = pipe(
    tap<T>(() => loader.lock(key)),
    switchMap(source),
    tap(() => loader.unlock(key)),
    finalize(() => loader.unlock(key)),
  );
  return operator;
};
